// Native details is usable without JavaScript. Enhance it with brief, cancellable motion.
if (!customElements.get('hp-photo-credits')) {
  customElements.define('hp-photo-credits', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.panel = this.querySelector('.hp-photo-credits__panel');
      this.expanded = this.details.open;
      this.summary.setAttribute('aria-expanded', String(this.expanded));
      this.summary.addEventListener('click', event => {
        event.preventDefault();
        this.setExpanded(!this.expanded);
      });
      this.details.addEventListener('toggle', () => {
        if (!this.animation) {
          this.expanded = this.details.open;
          this.summary.setAttribute('aria-expanded', String(this.expanded));
        }
      });
    }
    setExpanded(expanded) {
      const start = this.details.open ? this.panel.getBoundingClientRect().height : 0;
      this.animation?.cancel();
      this.animation = null;
      this.expanded = expanded;
      this.summary.setAttribute('aria-expanded', String(expanded));
      this.panel.inert = !expanded;
      this.details.open = true;
      const finish = () => { this.details.open = expanded; this.animation = null; };
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !this.panel.animate) { finish(); return; }
      const animation = this.panel.animate([{height:start+'px'},{height:(expanded ? this.panel.scrollHeight : 0)+'px'}],{duration:180,easing:'ease-out'});
      this.animation = animation;
      animation.onfinish = finish;
    }
    disconnectedCallback() { this.animation?.cancel(); this.animation = null; }
  });
}
